import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { ThemeProvider } from 'styled-components'
// import LogRocket from 'logrocket'
import Snackbar from 'material-ui/Snackbar'
import withWidth from '../../../utils/withWidth'

import { Grid, Row, Col } from '../../../components/Grid'
import FullPageLoading from '../../../components/FullPageLoading'

import MenuDrawer from '../containers/MenuDrawer'
import ProfileDrawer from '../containers/ProfileDrawer'
import AppBar from '../containers/AppBar'
import Content from './Content'
import moment from 'moment'

class AuthenticatedLayout extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    message: PropTypes.string,
    duration: PropTypes.number,
    isOpen: PropTypes.bool.isRequired,
    refresh: PropTypes.bool.isRequired,
    hideNotification: PropTypes.func.isRequired,
    repeatCheckRole: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    width: PropTypes.number.isRequired,
    openMenuDrawer: PropTypes.bool.isRequired,
    openProfileDrawer: PropTypes.bool.isRequired,
    drawerDocked: PropTypes.bool.isRequired,
    dockDrawer: PropTypes.func.isRequired,
    toggleMenu: PropTypes.func.isRequired,
    toggleProfile: PropTypes.func.isRequired,
    user: PropTypes.object,
    location: PropTypes.object,
    pushLocation: PropTypes.func,
    theme: PropTypes.object.isRequired
  }

  componentWillMount() {
    const { user, pushLocation, location } = this.props
    // if no user or login expiration return login
    if (!user) {
      const { pathname, search } = location
      pushLocation(`login?returnUrl=${pathname}${search}`)
    }
    if(user && isNaN(user.EmployeeId)) {
      pushLocation('expiredLogin')
    }
    if (user && moment().diff(moment.unix(user.exp), 'days') > 0)
      pushLocation('expiredLogin')
  }

  componentDidMount() {
    this.props.dockDrawer(this.props.width >= 3)
    this.props.toggleMenu(this.props.width >= 3)
    if (process.env.NODE_ENV === 'production') {
      if (this.props.user) {
        /* LogRocket.identify(this.props.user.StaffId, {
          name: this.props.user.DisplayName,
          email: this.props.user.Email
        }) */
      }
    }

    this.checkRole()
  }

  checkRole = () => {
    setTimeout(() => {
      this.handleCheckRole() // do it once and then start it up ...
      setInterval(() => this.handleCheckRole(), 5 * 60 * 1000)
    }, 1000)
  }

  handleCheckRole = () => {
    this.props.repeatCheckRole()
  }

  componentWillReceiveProps(nextProps) {
    this.props.dockDrawer(nextProps.width >= 3)

    if (nextProps.width !== this.props.width) {
      this.props.toggleProfile(false)
      this.props.toggleMenu(nextProps.width >= 3)
    }
  }

  toggleMenuDrawer = () => {
    const { openMenuDrawer, toggleMenu } = this.props
    toggleMenu(!openMenuDrawer)
  }

  toggleProfileDrawer = () => {
    const { openProfileDrawer, toggleProfile } = this.props
    toggleProfile(!openProfileDrawer)
  }

  handleSnackbarRequestClose = reason => {
    reason === 'timeout' && this.props.hideNotification()
  }
  goToProfilePage = () => {
    this.props.pushLocation(`/profile/${this.props.user.ID}`)
  }
  render() {
    const {
      drawerDocked,
      openMenuDrawer,
      openProfileDrawer,
      theme
    } = this.props
    return (
      <MuiThemeProvider muiTheme={theme}>
        <ThemeProvider theme={theme}>
          <Grid fluid>
            <Row>
              <AppBar
                onProfileDrawerToggle={this.toggleProfileDrawer}
                onMenuDrawerToggle={this.toggleMenuDrawer}
                drawerDocked={drawerDocked}
              />
            </Row>
            <Grid fluid>
              <Content noGutters marginLeft={drawerDocked && openMenuDrawer}>
                <Col>{this.props.children}</Col>
              </Content>
            </Grid>

            {/* Menu Drawer */}
            <MenuDrawer
              open={openMenuDrawer}
              docked={drawerDocked}
              onRequestChange={this.toggleMenuDrawer}
              // itemsMenuNews={itemsMenuNews}
            />

            {/* Profile Drawer */}
            <ProfileDrawer
              open={openProfileDrawer}
              onRequestChange={this.toggleProfileDrawer}
            />

            <Snackbar
              message={this.props.message}
              autoHideDuration={this.props.duration}
              open={this.props.isOpen}
              onRequestClose={this.handleSnackbarRequestClose}
              action={this.props.refresh && 'Refresh'}
              onActionTouchTap={() => window.location.reload()}
            />

            {this.props.isLoading && <FullPageLoading />}
          </Grid>
        </ThemeProvider>
      </MuiThemeProvider>
    )
  }
}

export default withWidth()(AuthenticatedLayout)



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/components/index.js